// generateIdempotencyKey генерирует ключ идемпотентности.
export function generateIdempotencyKey() {
    if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }

    if (typeof crypto !== "undefined" && typeof crypto.getRandomValues === "function") {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        return Array.from(bytes)
            .map((value) => value.toString(16).padStart(2, "0"))
            .join("");
    }

    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}
